import { getWeeksInMonth } from "@internationalized/date"
import {
  type AriaCalendarGridProps,
  useCalendarGrid,
} from "@react-aria/calendar"
import { useLocale } from "@react-aria/i18n"
import type { CalendarState } from "@react-stately/calendar"

import { Text } from "../Text"
import { CalendarCell } from "./CalendarCell"
import styles from "./CalendarGrid.module.css"

type Props = AriaCalendarGridProps & {
  state: CalendarState
}

export const CalendarGrid = ({ state, ...props }: Props) => {
  const { locale } = useLocale()
  const { gridProps, headerProps, weekDays } = useCalendarGrid(props, state)

  // Get the number of weeks in the month so we can render the proper number of rows.
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale)

  return (
    <table {...gridProps} className={styles.root}>
      <thead {...headerProps}>
        <tr>
          {weekDays.map((day, index) => (
            <th key={index}>
              <Text variant="smallBold" color="grey12" noWrap>
                {day}
              </Text>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...new Array(weeksInMonth).keys()].map((weekIndex) => (
          <tr key={weekIndex}>
            {state
              .getDatesInWeek(weekIndex)
              .map((date, i) =>
                date ? (
                  <CalendarCell key={i} state={state} date={date} />
                ) : (
                  <td key={i} />
                ),
              )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
